export class StructuredOperationFileModel {
  tempId: string = null;
  comment: string = null;
  fileId: number = null;
  ticketId: number = null;
  user: string = null;
  groupId: number = null;
  workflowStatusId: number = null;
  workflowStatus: string = null;
  subTypeAssetId: number = null;
}
